import actionTypes from './constants';

/* */
const now = new Date();
const initialState = {
  list: [],
  calendar: {
    month: now.getMonth(),
    year: now.getFullYear(),
  },
};

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_EVENTS:
      return {
        ...state,
        list: action.payload,
      };
    case actionTypes.SET_CALENDAR:
      return {
        ...state,
        calendar: action.payload,
      };
    default:
      return state;
  }
};
